import {
  progress_bar_styles_default
} from "./chunk.BEY2DKBZ.js";
import {
  LocalizeController
} from "./chunk.RQU6SOEM.js";
import {
  i2
} from "./chunk.XPDKWWJW.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  l
} from "./chunk.Z4OOI5NQ.js";
import {
  e,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.DACWCOGG.js
var SlProgressBar = class extends s4 {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController(this);
    this.value = 0;
    this.indeterminate = false;
    this.label = "";
  }
  render() {
    return $`<div part="base" class=${o({
      "progress-bar": true,
      "progress-bar--indeterminate": this.indeterminate
    })} role="progressbar" title=${l(this.title)} aria-label=${this.label.length > 0 ? this.label : this.localize.term("progress")} aria-valuemin="0" aria-valuemax="100" aria-valuenow=${this.indeterminate ? 0 : this.value} ><div part="indicator" class="progress-bar__indicator" style=${i2({ width: `${this.value}%` })}>${!this.indeterminate ? $`<span part="label" class="progress-bar__label"><slot></slot></span>` : ""}</div></div>`;
  }
};
SlProgressBar.styles = progress_bar_styles_default;
__decorateClass([
  e({ type: Number, reflect: true })
], SlProgressBar.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlProgressBar.prototype, "indeterminate", 2);
__decorateClass([
  e()
], SlProgressBar.prototype, "label", 2);
__decorateClass([
  e()
], SlProgressBar.prototype, "lang", 2);
SlProgressBar = __decorateClass([
  n("sl-progress-bar")
], SlProgressBar);

export {
  SlProgressBar
};
